
















import { Component, Vue } from 'vue-property-decorator';
import BenorLogo from '@/assets/img/benor-logo.svg';
import ButgbUbatcLogo from '@/assets/img/butgb-ubatc-logo.svg';
import CoproLogo from '@/assets/img/copro-logo.svg';

@Component({
    components: {
        BenorLogo,
        ButgbUbatcLogo,
        CoproLogo
    }
})
export default class PartnerLogoBelt extends Vue {}
